import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import enCommon from "./locales/en/common.json";
import enApp from "./locales/en/app.json";
import enTracking from "./locales/en/tracking.json";
import zhCommon from "./locales/zh/common.json";
import zhApp from "./locales/zh/app.json";
import zhTracking from "./locales/zh/tracking.json";

export const supportedLanguages = ["en", "zh"] as const;
export type SupportedLanguage = (typeof supportedLanguages)[number];

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { common: enCommon, app: enApp, tracking: enTracking },
      zh: { common: zhCommon, app: zhApp, tracking: zhTracking },
    },
    fallbackLng: "en",
    supportedLngs: supportedLanguages,
    nonExplicitSupportedLngs: true,
    defaultNS: "common",
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
